import {useEffect, useRef, useState} from 'react';

import {Menu} from 'primereact/menu';
import {Button} from 'primereact/button';
import {Dropdown} from 'primereact/dropdown';
import {ToggleButton} from 'primereact/togglebutton';
import {SelectButton} from 'primereact/selectbutton';
import {InputNumber} from 'primereact/inputnumber';
import {InputText} from 'primereact/inputtext';
import {FormatDisplay} from '../../../../shared/format';

export const Toolbar = (props) => {

  const menuAlign = useRef(null);
  const menuSpacing = useRef(null);

  const [fontSize, setFontSize] = useState(10);
  const [bold, setBold] = useState(false);
  const [italic, setItalic] = useState(false);
  const [underline, setUnderline] = useState(false);
  const [textAlign, setTextAlign] = useState('');
  const [width, setWidth] = useState(0);
  const [widthUnit, setWidthUnit] = useState('%');
  const [color, setColor] = useState('#000000');

  useEffect(() => {
    setFontSize(props.targetSetting.fontSize || 10);
    setBold(props.targetSetting.bold);
    setItalic(props.targetSetting.italic);
    setUnderline(props.targetSetting.underline);
    setTextAlign(props.targetSetting.textAlign);
    setColor(props.targetSetting.color || '#000000');

    const _width = props.targetSetting.width || props.targetSetting.targetWidth;
    if (_width) {
      const _widthUnit = _width.replace(/[^A-Za-z]/g, '');
      setWidthUnit(_widthUnit || '%');
      setWidth(parseFloat(_width));
    } else {
      setWidthUnit('%');
      setWidth(0);
    }
  }, [props.targetSetting]);

  const alignItems = [
    {label: 'Căn theo tiêu đề'},
    {label: 'Căn theo tiêu đề dài nhất'},
    {label: 'Căn theo tiêu đề dài nhất bao gồm dấu :'},
    {label: 'Người mua người bán căn theo tiêu đề dài nhất bao gồm dấu :'},
  ];
  const spacingItemClick = ({item}) => {
    if (item) {
      if (props.targetId) {
        let event = new CustomEvent('setCss', {
          detail: {selector: `#${props.targetId}`, property: 'letter-spacing', value: `${item.label}px`}
        });
        props.dispatchEvent(event);

        loadForm();
      }
    }
  }
  const spacingItems = [
    {label: '0', command: spacingItemClick},
    {label: '-0.5', command: spacingItemClick},
    {label: '0.5', command: spacingItemClick},
    {label: '1', command: spacingItemClick}
  ];
  // @ts-ignore
  const sizes = [...Array(15).keys()].map(i => i + 10);
  const fontSizeItems = [];
  sizes.forEach((size) => {
    fontSizeItems.push({value: size, label: size});
  });

  const textAlignOptions = [
    {icon: 'pi pi-align-left', value: 'left'},
    {icon: 'pi pi-align-center', value: 'center'},
    {icon: 'pi pi-align-right', value: 'right'}
  ];
  const textAlignTemplate = (option) => {
    return <i className={option.icon}/>;
  }

  const loadForm = () => {
    if (props.formId) {
      let event = new CustomEvent('loadForm', {
        detail: {selector: props.formId}
      });
      props.dispatchEvent(event);
    }
  }

  const onFontSizeChange = (value) => {
    if (props.targetId) {
      setFontSize(value);

      let event = new CustomEvent('setCss', {
        detail: {selector: `#${props.targetId}`, property: 'font-size', value: `${value}px`}
      });
      props.dispatchEvent(event);

      loadForm();
    }
  }

  const onBoldChange = (value) => {
    if (props.targetId) {
      setBold(value);

      let event;
      if (value) {
        event = new CustomEvent('setCss', {
          detail: {selector: `#${props.targetId}`, property: 'font-weight', value: `bold`}
        });
      } else {
        event = new CustomEvent('setCss', {
          detail: {selector: `#${props.targetId}`, property: 'font-weight', value: ``}
        });
      }
      props.dispatchEvent(event);

      loadForm();
    }
  }

  const onItalicChange = (value) => {
    if (props.targetId) {
      setItalic(value);

      let event;
      if (value) {
        event = new CustomEvent('setCss', {
          detail: {selector: `#${props.targetId}`, property: 'font-style', value: `italic`}
        });
      } else {
        event = new CustomEvent('setCss', {
          detail: {selector: `#${props.targetId}`, property: 'font-style', value: ``}
        });
      }
      props.dispatchEvent(event);

      loadForm();
    }
  }

  const onUnderlineChange = (value) => {
    if (props.targetId) {
      setUnderline(value);

      let event;
      if (value) {
        event = new CustomEvent('setCss', {
          detail: {selector: `#${props.targetId}`, property: 'text-decoration', value: `underline`}
        });
      } else {
        event = new CustomEvent('setCss', {
          detail: {selector: `#${props.targetId}`, property: 'text-decoration', value: ``}
        });
      }
      props.dispatchEvent(event);

      loadForm();
    }
  }

  const onTextAlignChange = (value) => {
    if (props.targetId) {
      setTextAlign(value);

      let event = new CustomEvent('setCss', {
        detail: {selector: `#${props.targetId}`, property: 'text-align', value}
      });
      props.dispatchEvent(event);

      loadForm();
    }
  }

  const onWidthUnitChange = (value) => {
    if (props.fieldId) {
      setWidthUnit(value);

      let event;
      if (props.targetSetting.targetWidth) {
        event = new CustomEvent('setCss', {
          detail: {selector: `#${props.targetId}`, property: 'width', value: `${width}${value}`}
        });
      } else {
        event = new CustomEvent('setCss', {
          detail: {selector: `#${props.fieldId}`, property: 'width', value: `${width}${value}`}
        });
      }
      props.dispatchEvent(event);

      loadForm();
    }
  }
  const onWidthChange = (value) => {
    if (props.fieldId) {
      setWidth(value);

      let event;
      if (props.targetSetting.targetWidth) {
        event = new CustomEvent('setCss', {
          detail: {selector: `#${props.targetId}`, property: 'width', value: `${value}${widthUnit}`}
        });
      } else {
        event = new CustomEvent('setCss', {
          detail: {selector: `#${props.fieldId}`, property: 'width', value: `${value}${widthUnit}`}
        });
      }
      props.dispatchEvent(event);

      loadForm();
    }
  }

  const onColorChange = (value) => {
    if (props.targetId) {
      setColor(value);

      let event = new CustomEvent('setCss', {
        detail: {selector: `#${props.targetId}`, property: 'color', value}
      });
      props.dispatchEvent(event);

      loadForm();
    }
  }

  const addField = () => {
    if (props.formId) {

      let event = new CustomEvent('addField', {
        detail: {selector: props.formId}
      });
      props.dispatchEvent(event);

      loadForm();
    }
  }
  const removeField = () => {
    if (props.fieldId) {

      let event = new CustomEvent('removeField', {
        detail: {selector: props.fieldId}
      });
      props.dispatchEvent(event);

      props.selectField();

      loadForm();
    }
  }

  return (
    <div className="grid template-editor">
      <div className="col-12 pb-0">
        <div className="grid">
          <div className="col-fixed" style={{width: '58px'}}>
            <Menu model={alignItems} popup ref={menuAlign} className="app-menu-26"/>
            <Button icon="pi pi-align-left" className="p-button-sm" onClick={(event) => menuAlign.current.toggle(event)} disabled={!props.formSetting.paddingTitle}/>
          </div>
          <div className="col-fixed p-0" style={{width: '5px'}}>
            <div className="divider-vertical"/>
          </div>
          <div className="col-fixed" style={{width: '78px'}}>
            <Dropdown className="p-inputtext-sm" value={fontSize} onChange={(e) => onFontSizeChange(e.value)} options={fontSizeItems} disabled={!props.targetId}/>
          </div>
          <div className="col-fixed p-0" style={{width: '5px'}}>
            <div className="divider-vertical"/>
          </div>
          <div className={props.targetId ? 'col-fixed font-style' : 'col-fixed font-style p-disabled'} style={{width: '111px'}}>
            <ToggleButton className="p-button-sm mr-1" checked={bold} onChange={(e) => onBoldChange(e.value)} onLabel="B" offLabel="B"/>
            <ToggleButton className="p-button-sm font-italic mr-1" checked={italic} onChange={(e) => onItalicChange(e.value)} onLabel="I" offLabel="I"
                          style={{paddingRight: '0.88rem'}}/>
            <ToggleButton className="p-button-sm underline" checked={underline} onChange={(e) => onUnderlineChange(e.value)} onLabel="U" offLabel="U"/>
          </div>
          <div className="col-fixed p-0" style={{width: '5px'}}>
            <div className="divider-vertical"/>
          </div>
          <div className="col-fixed" style={{width: '154px'}}>
            <SelectButton className="p-button-sm" value={textAlign} options={textAlignOptions} onChange={(e) => onTextAlignChange(e.value)} itemTemplate={textAlignTemplate} disabled={!props.targetId}/>
          </div>
          <div className="col-fixed p-0" style={{width: '5px'}}>
            <div className="divider-vertical"/>
          </div>
          <div className="col">
            <Button icon="pi pi-plus" className="p-button-rounded p-button-info p-button-outlined p-button-sm p-button-2rem" onClick={addField}
                    disabled={!props.formSetting.addForm}/>
          </div>
        </div>
      </div>
      <div className="col-12 pt-0 pb-1">
        <div className="grid">
          <div className="col-fixed" style={{width: '257px'}}>
            <div className="p-fluid mt-1">
              <div className="field grid mb-0">
                <div className="col-fixed pt-2" style={{width: '68px'}}>
                  <span>Độ rộng</span>
                </div>
                <div className="col">
                  <InputNumber locale={FormatDisplay.locales} className="p-inputtext-sm" value={width} onChange={e => onWidthChange(e.value)} showButtons min={0} maxFractionDigits={2} disabled={!props.targetId}/>
                </div>
                <div className="col-fixed" style={{width: '60px'}}>
                  <InputText className="p-inputtext-sm" value={widthUnit} onChange={e => onWidthUnitChange(e.target.value)} disabled={!props.targetId}/>
                </div>
              </div>
            </div>
          </div>
          <div className="col-fixed p-0" style={{width: '5px'}}>
            <div className="divider-vertical"/>
          </div>
          <div className="col-fixed pt-3" style={{width: '154px'}}>
            <input type="color" value={color} onChange={(e) => onColorChange(e.target.value)} disabled={!props.targetId}/>

            <Menu model={spacingItems} popup ref={menuSpacing}/>
            <Button icon="pi pi-arrows-h" className="p-button-info p-button-outlined p-button-sm ml-2" onClick={(event) => menuSpacing.current.toggle(event)} disabled={!props.targetId}
                    style={{paddingTop: '0.3rem', paddingBottom: '0.3rem'}}/>
          </div>
          <div className="col-fixed p-0" style={{width: '5px'}}>
            <div className="divider-vertical"/>
          </div>
          <div className="col">
            <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-button-outlined p-button-sm p-button-2rem" onClick={removeField}
                    disabled={!props.fieldDeletable}/>
          </div>
        </div>
      </div>
    </div>
  );
}
